/**
 * "تم حفظ كلمة المرور" after the first-login change (roundtable 2, B7).
 *
 * The change re-issues the session, and the rebind bumps the private-session
 * generation more than once: the change-password page that asked for the
 * toast is gone by the time the seller lands in her store (the portal remounts
 * on every generation, toast provider included). So the page does not toast;
 * it leaves this one-shot flag for the tab, and `PasswordSavedNotice` in
 * `app/locale.tsx` (above every route) shows the toast
 * once the session has settled — whichever route she lands on.
 */
const KEY = "seller_password_saved_notice_v1";

export function markPasswordSavedNotice(): void {
  try {
    window.sessionStorage.setItem(KEY, "1");
  } catch {
    /* private mode — she lands without the toast, still signed in */
  }
}

export function clearPasswordSavedNotice(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* private mode */
  }
}

/** True once per mark: reading it clears it. */
export function consumePasswordSavedNotice(): boolean {
  try {
    if (window.sessionStorage.getItem(KEY) !== "1") return false;
    window.sessionStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}
